/**
 * Created by zjs on 2017/08/30
 */
import Vue from 'vue'
import Vuex from 'vuex'
import actions from './actions'
import mutations from './mutations'

import route from './route'
import bill from './bill'

Vue.use(Vuex)

const state = {
    /* -- 全局配置字符 -- */
    tokon: '', // 登录验证令牌
    tokonKey: 'TOKON_KEY', // 用于本地存储tokon的key
    tokonMark: '/MARK', // url中识别tokon的标识字符串
    localConfigKey: 'LOCAL_CONFIG', // 配置本地缓存的key
    /* -- 账号相关 -- */
    authorizd: false, // 标识是否已登录
    userInfo: {}, // 当前登录用户的信息
    /* -- 路由配置 -- */
    rootRoute: '/', // 根路由
    loginRouter: '/login', // 登录页面路由
}

const getters = {
    /* -- 全局配置字符 -- */
    tokon: state => state.tokon,
    tokonKey: state => state.tokonKey,
    tokonMark: state => state.tokonMark,
    localConfigKey: state => state.localConfigKey,
    /* -- 账号相关 -- */
    authorizd: state => state.authorizd,
    userInfo: state => state.userInfo,
    /* -- 路由配置 -- */
    rootRoute: state => state.rootRoute,
    loginRouter: state => state.loginRouter
}

export default new Vuex.Store({
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
    modules: {
        route: {
            namespaced: true,
            ...route
        },
        bill: {
            namespaced: true,
            ...bill
        }
    }
})